module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("TABLE OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_c('strong', [_vm._v("Chapter 1")])])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_c('strong', [_vm._v("My Story: From Atheism to Faith")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev1"
    }
  }, [_vm._v("Exploring Success")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev2"
    }
  }, [_vm._v("A New Discovery")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev3"
    }
  }, [_vm._v("My Personal Reckoning")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev4"
    }
  }, [_vm._v("Amazing Discoveries")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev5"
    }
  }, [_vm._v("Wrestling with Tough Questions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch1lev6"
    }
  }, [_vm._v("A Few Personal Conclusions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: The World of Wonder")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Incredible Cosmos")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Precision of Our Solar System")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Wonderful World and Its Partners")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Mountaintop Experience")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Supernatural Fingerprint")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Story of Life")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Marvelous Dance of Life")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life’s Unlearned Behavior")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Human Ingredient")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02#ch2lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Findings")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: The Scriptures")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discovered Treasure")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Authenticating Process")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Authenticating Process: The Prophecies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miracles")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Point of Reckoning")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch3lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Affirmed the Divine Authorship and Authority of Scripture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Jesus: God Himself as Messenger")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Lack of Understanding")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Great Expectations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Becomes Human")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Implications of a Divine Incarnation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus as a Boy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus: A Man of Intense Emotions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Public Life")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Early Teachings")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch4lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Different Way of Teaching: the Parables")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: Jesus’ Farewell Tour")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Farewell Tour")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crowds in Bethany")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Difficulty Following Jesus")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Final Straw")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus’ Final Steps")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Passover Meal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Betrayed, Scorned, Beaten, and Crucified")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch5lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eternal Impact of Jesus’ Death")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: The Education of Pain")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystery and Challenge of Human Suffering")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cause of Pain: Corruption")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Works for Our Redemption")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wildfire Phenomenon")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shock: the Human Earthquake")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power of Pain")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Explanations from the Scriptures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystery of Unanswered Questions")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch6lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My New Understanding About Pain")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: The Body")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Tells It Like It Is")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinks in a Skeptic’s Armor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clearing My Mind of Bias")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blinders Came Off")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What I Uncovered")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What a Fellowship!")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Tapestry of Spiritual Gifts")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Body’s Strength")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Difficulties In the Body")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch7lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Perpetual Relay of Truth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: Our Consciousness")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Loving and Learning")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Avoiding My Doubts")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Truth is Important")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Looking to Science for Answers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Investigation of Consciousness")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Philosophy of the Mind")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What the Scriptures Say About Consciousness")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8sub1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Creativity")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8sub2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Logical Thinking")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab5"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8sub3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Ability to Distinguish Right from Wrong")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab5"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8sub4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Our Amazing Range of Emotions")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Most Significant Emotion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08#ch8lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Conclusions about Our Consciousness")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Messenger: The Tale of Two Eternal Cities")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven’s Gate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reality of Heaven: Life Fulfilled")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven Intersects Our World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Reality of Hell")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch9lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heaven’s Gate")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("The Counterfeit Messengers")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unveiling the Impersonator")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Satan’s Covert Nature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Few Specific Tactics")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Past")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Attacks on God’s Messengers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Satan’s Attack in Paradise")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man’s Distorted Culture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Family and Relationships")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Satan, the Master of Bait")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Promises—Satan’s Limitations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 11")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Great Plan (Part 1)")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Turning Point")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Harmonious Truth")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11lev3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God, Man, and Redemption")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11lev4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What No One Explained to Me")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 12")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("God’s Great Plan (Part 2)")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12lev1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of the Divine Design")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12lev2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facing My Skeptical Attitude")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 13")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("My New Life")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("End Notes")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/thanks#spe",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Special Thanks")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/michael#mic",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About Michael")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toctab1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/permission#use",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Permission To Use")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0